import { isLocal } from './../../constants';
/**
 * 多语言处理方法(当前语言类型来自主站),本地系统暂时只支持中文
 */
/**
 * 语言；列表(组件处理组件需要同步)
 */
export const locale = isLocal ? 'zh' : localStorage.getItem('locale') || 'zh';

export type langObject = {
  zh?: string;
  en?: string;
  ja?: string;
};
export const localesMap = {
  zh: '中文',
  en: '英文',
  ja: '日文'
};
export const langUtil = {
  //获取该语言信息中的某个语言(默认为当前系统语言)对应的文本
  get: (lang: any, lc = locale): string => {
    try {
      return langUtil.parse(lang)[lc] || '';
    } catch (error) {
      return lang;
    }
  },
  //设置语言信息中的某个语言(默认为当前语音)内容
  set: (lang: string, str: string, lc = locale): string => {
    try {
      let c = langUtil.parse(lang);
      c[lc] = str;
      return langUtil.stringIfy(c);
    } catch (error) {
      //假如格式化报错，则强制为空对象处理
      let b: langObject = {};
      b[lc as keyof langObject] = str;
      return langUtil.stringIfy(b);
    }
  },
  //语言字符串解析
  parse: (lang: string) => {
    return JSON.parse(lang);
  },
  //语言对象序列化
  stringIfy: (lang: langObject) => {
    return JSON.stringify(lang);
  },
  //判断是否全部为空
  allIsEmpty: (lang: any, emptyString?: string): boolean => {
    let flag = false;
    Object.keys(localesMap).forEach((lc) => {
      if (!langUtil.get(lang, lc).trim()) {
        flag = true;
      }
    });
    return flag;
  }
};
